<template>
    <div class="videoCenter">
        <div class="borderLine borderTop newTitleBox yahei">视频中心</div>
        <div class="borderLine list">
            <videoList :dataList="dataList"></videoList>
        </div>
        <div class="pager">
            <comPager :totalPages="total"></comPager>
        </div>
    </div>
</template>

<script>
import videoList from "./videoList";
import comPager from "../comPager";
import newsList from "./newsList";
export default {
    name: "videoCenter",
    data(){
        return{
            dataList:[{},{}],
            total:1,
        }
    },
    components:{
        videoList,
        comPager
    }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/auctionCompany.scss";

</style>